import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {XS} from "../constants/constants";

const styles = (theme) => ({
    mainBackground: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        backgroundColor: 'rgba(255,255,255,0.95)',
        '& .alert-content': {
            color: 'green',
            textAlign: 'center',
            fontSize: '35px',
            lineHeight: '40px !important',
            fontWeight: 500,
            '&.error-content': {
                color: 'red'
            },
            [theme.breakpoints.down(XS)]: {
                fontSize: "25px",
            },
        }
    },
    backgroundContent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        textAlign: 'center'
    },
    contentTitle: {
        fontSize: '40px',
        color: 'blue',
        paddingBottom: 15,
        [theme.breakpoints.down(XS)]: {
            fontSize: "25px",
        },
    },
    closeAlert: {
        color: '#444',
        border: '1px solid #444',
        borderRadius: 10,
        padding: '5px 8px',
        cursor: 'pointer',
        transition: '0.3s',
        marginBottom: 25,
        '&:hover':{
            backgroundColor: '#444',
            color: '#fff'
        }
    },
    alertWrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        flexDirection: 'column',
        marginBottom: 15,
        transition: '0.4s'
    }
});

class UploadingAndAlertAction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openAlert: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (!state.openAlert && props.alertType) {
            return {
                openAlert: true
            }
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.openAlert) {
            setTimeout(() => {
                this.setState({openAlert: false})
                if (this.props.onClose && typeof this.props.onClose === "function") {
                    this.props.onClose()
                }
            }, 5000);
        }
    }

    closeAlertAction = () => {
        this.setState({openAlert: false})
        if (this.props.onClose && typeof this.props.onClose === "function") {
            this.props.onClose()
        }
    }

    render() {
        const {classes, t, alertType, isLoading} = this.props;
        return (isLoading || alertType ?
            <div className={classes.mainBackground}>
                {!alertType ? <div className={classes.backgroundContent}>
                    <div className={classes.contentTitle}>{t("loadingFilesInProgress")}</div>
                    <CircularProgress/>
                </div> : this.state.openAlert && <div className={classes.alertWrapper} >
                    <div className={classes.closeAlert} onClick={this.closeAlertAction}>{t("button.close")}</div>
                    {(alertType == "error" ?
                        <div className={`alert-content error-content`}>
                            {this.props.message ? this.props.message : this.props.t("form.error.occurred")}
                        </div> :
                        <div className={`alert-content`}>
                            {this.props.message ? this.props.message : this.props.t("form.success.save_ok")}
                        </div>)}
                </div>}
            </div> : "")
    }

}

UploadingAndAlertAction.propTypes = {
    classes: PropTypes.object.isRequired
,
}

;
export default compose(withTranslation(), withStyles(styles))(UploadingAndAlertAction);